/* eslint-disable react/forbid-prop-types */
import React, {forwardRef, memo} from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import styled from 'styled-components';
import {isEqual} from 'lodash';
import {labels} from '../../../../../../../../../util/utils';
import {getAllControls} from '../../../../../../../../../selectors/ISA315/selectors';
import ControlsContainer from './ControlsContainer';
import {alertIcErrorOutline24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {getScotControls, getControlsAccumulator} from '../../../../../../../../../selectors/ISA315/selectors';
import PropTypes from 'prop-types';
import Icon from '../../../../../../../BaseComponentWrappers/MotifIcon';

export const ViewControls = forwardRef((props, ref) => {
	const {scot, documentId, bodyId} = props;

	const itApplications = useSelector((state) => state.bodiesSpecial.itApplications);
	const controls = useSelector((state) => state.bodiesSpecial.controls);

	const detailedControls = useSelector((state) => {
		return getAllControls(state).filter(
			(control) =>
				getScotControls(state, scot.id).includes(control.id) &&
				!getControlsAccumulator(state, scot, itApplications, controls).controlsWithNoItApps.all.includes(control.id)
		);
	}, shallowEqual);

	const detailedControlsWithNoItApps = useSelector((state) => {
		return getAllControls(state).filter((control) =>
			getControlsAccumulator(state, scot, itApplications, controls).controlsWithNoItApps.all.includes(control.id)
		);
	}, shallowEqual);

	return (
		<StyledViewControl>
			<section className="controlWrapper">
				{detailedControlsWithNoItApps?.length > 0 && (
					<>
						<section className="controls-without-it-apps">
							<section className="controls-without-it-apps-title">
								<Icon src={alertIcErrorOutline24px} />
								<span>{`${labels.controlsWithoutRelatedItApps} - ${detailedControlsWithNoItApps.length}`}</span>
							</section>
							<ControlsContainer
								hideEmptySections
								controls={detailedControlsWithNoItApps}
								documentId={documentId}
								bodyId={bodyId}
							/>
						</section>
						<section className="controls-with-it-apps">
							<span className="controls-with-it-apps-title">{`${labels.controlsWithRelatedItApps}${
								detailedControls.length > 0 ? ' - ' + detailedControls.length : ''
							}`}</span>
						</section>
					</>
				)}
				<ControlsContainer controls={detailedControls} documentId={documentId} bodyId={bodyId} />
			</section>
		</StyledViewControl>
	);
});

ViewControls.displayName = 'ViewControls';

ViewControls.propTypes = {
	scot: PropTypes.object,
	engagementId: PropTypes.number,
	documentId: PropTypes.string,
	documentEngagementId: PropTypes.number,
	bodyId: PropTypes.number
};

const StyledViewControl = styled.section`
	.controls-without-it-apps {
		margin: var(--px-25) 0;
	}
	.motif-icon svg {
		height: var(--px-16) !important;
		width: var(--px-16) !important;
		vertical-align: middle;
	}
	.controls-without-it-apps-title {
		color: var(--red-600) !important;
		font-weight: bold;
		svg {
			fill: var(--red-600) !important;
			margin-right: var(--px-5);
		}
	}
	.controls-with-it-apps {
		font-weight: 600;
	}
	.select {
		margin-bottom: var(--px-10);
		.select-error {
			.show {
				font-size: var(--px-12) !important;
				color: var(--red-600) !important;
				.medium {
					fill: var(--red-600);
					margin: var(--px-4) var(--px-5) 0 0;
					width: var(--px-16);
					height: var(--px-16);
				}
			}
		}
		.header {
			display: block;
			.header-label {
				font-size: var(--px-14);
				font-weight: 300;
				line-height: normal;
				color: var(--neutrals-900);
				margin-bottom: var(--px-5);
			}
			.header-ellipsis {
				font-size: var(--px-16);
				font-weight: bold;
			}
		}
	}
`;

export default memo(ViewControls, isEqual);
